import { useState, useEffect } from 'react';
import { userCloudApiFetch as apiFetch } from './userCloudApi';
import {
  loadPlaylists,
  invalidateAndReloadPlaylists,
  getPlaylistLoadState,
  resetUserPlaylistsForTests,
  subscribePlaylists,
  prependPlaylist,
} from './userPlaylistsStore';
import { addTrackToPlaylist } from './userPlaylistsTracks';

export {
  loadPlaylists,
  invalidateAndReloadPlaylists,
  getPlaylistLoadState,
  resetUserPlaylistsForTests,
  addTrackToPlaylist,
};

export async function createPlaylist(name) {
  const data = await apiFetch('/api/user/playlists', 'POST', { name });
  if (data?.playlist) {
    prependPlaylist(data.playlist);
    return data.playlist;
  }
  return null;
}

export function usePlaylists() {
  const snap = getPlaylistLoadState();
  const [pls, setPls] = useState(snap.playlists);
  const [loading, setLoading] = useState(!snap.loaded || snap.loading);
  const [error, setError] = useState(snap.error);
  useEffect(() => {
    const unsub = subscribePlaylists((next) => {
      setPls(next.playlists);
      setLoading(next.loading);
      setError(next.error);
    });
    if (!getPlaylistLoadState().loaded) loadPlaylists();
    return unsub;
  }, []);
  return { playlists: pls, loading, error, createPlaylist, addTrackToPlaylist, reload: loadPlaylists };
}
